<div class="search-bar-container">
  <div class="top-row">
    <input
      [ngModel]="value"
      (ngModelChange)="valueChange.emit($event)"
      (keyup)="filterByText($event.target['value'])"
      class="search-bar-input"
      placeholder="{{ placeholder ? (placeholder | translate) : ('generic.search.standard' | translate) }}"
      type="text" />
    @if (button) {
      <button (click)="buttonClicked.emit()" class="secondary inverse">
        {{ button?.placeholder | translate }}
      </button>
    }
    <ng-content></ng-content>
  </div>
  @if (filters) {
    <app-search-bar-filter (changeFilter)="applyFilter($event)" [filterService]="filterService" [filters]="filters"></app-search-bar-filter>
  }
</div>
